"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterRequest = void 0;
var enum_1 = require("../../../library/enum");
var CenterRequest = /** @class */ (function () {
    function CenterRequest() {
        this.name = '';
        this.password = '';
        this.beginTime = new Date();
        this.sex = new enum_1.ENUM([{ key: 'male', value: '男' }, { key: 'female', value: '女' }], 'male');
        this.age = 10;
    }
    return CenterRequest;
}());
exports.CenterRequest = CenterRequest;
;
//# sourceMappingURL=center.request.js.map